import * as React from "react";
import { CSSProperties } from "react";

export function Footer() {
  return (
    <div style={footerStyle}>
      <span style={titleFooter}>&copy; 2020 Toorak Capital Partners</span>
      <a
        style={footerLink}
        href="https://fake-privacy-policy.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy
      </a>
      <a
        style={footerLink}
        href="https://fake-tnc-link.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms & Conditions
      </a>
      <a
        style={footerLink}
        href="https://fake-cookie-link.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        Cookies
      </a>
    </div>
  );
}

const footerStyle: CSSProperties = {
  flexDirection: "row",
  justifyContent: "flex-end",
  position: "fixed",
  left: "0",
  bottom: "0",
  width: "100%",
  backgroundColor: "grey",
  color: "white",
  display: "flex",
};

const titleFooter: CSSProperties = {
  marginRight: "auto",
  padding: "20px",
};

const footerLink: CSSProperties = {
  margin: 20,
  cursor: "pointer",
  textDecorationLine: "none",
  color: "white",
};
